export default __webpack_public_path__ + "static/media/shopifystorelisting.12a54aad.png";